/* eslint-disable new-cap */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import ABCyaLib from '@abcya/abcya_lib';

export default class Results extends Phaser.Scene {
  static get KEY() { return 'Results'; }

  create() {
    this.cameras.main.setBackgroundColor('#FFFFFF');

    this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);
    this.player = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    this.curGoFrame = 0;

    this.checkerHeader = ABCyaPhaser.Images.addImage(0, 0, 'CheckeredHeader', this).setOrigin(0, 0);
    this.checkerFooter = ABCyaPhaser.Images.addImage(0, this.mid.y * 2, 'CheckeredHeader', this).setScale(1, -1)
      .setOrigin(0, 0);

    this.flagContainer = this.add.container(700, 120);
    this.flagleft = ABCyaPhaser.Images.addImage(0, 0, 'CheckeredFlagIcon', this.flagContainer).setOrigin(0, 0);
    this.flagleft.x = 0;
    this.flagleft.y = 80;
    this.flagright = ABCyaPhaser.Images.addImage(0, 0, 'CheckeredFlagIcon', this.flagContainer).setOrigin(0, 0);
    this.flagright.scaleX = -1;
    this.flagright.y = 80;

    this.flagContainer.alpha = 0;

    this.lblResults = this.add.bitmapText(0, 0, 'asapBoldItalic', ABCyaPhaser.Localization.instance.getLocalizedString('results.header'), 90);
    this.flagContainer.add(this.lblResults);

    this.lblResults.x = this.flagleft.x + this.flagleft.getBounds().width;
    this.lblResults.y = 0;
    this.flagright.x = this.lblResults.x + this.lblResults.width + 100;

    this.coinIcon = ABCyaPhaser.Images.addImage(0, 0, gameData.GAME_TYPE === 'jr' && gameData.coinmode === 'odd' ? 'ScoreCoinSilver' : 'ScoreCoin', this.flagContainer).setOrigin(0, 0);
    this.coinIcon.x = this.flagleft.x + this.flagleft.getBounds().width + ABCyaLib.Environment.instance.gameConfig.results.coinX;
    this.coinIcon.y = this.flagleft.y + this.flagleft.getBounds().height / 2 - this.coinIcon.getBounds().height / 2;

    this.xIcon = ABCyaPhaser.Images.addImage(0, 0, 'ScoreX', this.flagContainer).setOrigin(0, 0);
    this.xIcon.x = 200 + ABCyaLib.Environment.instance.gameConfig.results.coinX;
    this.xIcon.y = this.coinIcon.y + this.coinIcon.getBounds().height / 2 - this.xIcon.getBounds().height / 2;

    this.lblScore = this.add.bitmapText(1, -2, 'asapBoldLarge', gameData.coinScore.toString(), 54);
    this.flagContainer.add(this.lblScore);

    this.lblScore.y = this.coinIcon.y + 5;
    this.lblScore.x = 280 + ABCyaLib.Environment.instance.gameConfig.results.coinX;

    this.lblPlayAgain = this.add.bitmapText(0, 0, 'asapBoldItalicSmall', ABCyaPhaser.Localization.instance.getLocalizedString('results.footer'), ABCyaLib.Environment.instance.gameConfig.results.titleSize);
    this.flagContainer.add(this.lblPlayAgain);

    this.lblPlayAgain.alpha = 0;
    this.lblPlayAgain.x = this.lblResults.x + this.lblResults.width / 2 - this.lblPlayAgain.width / 2;
    this.lblPlayAgain.y = this.flagleft.y + this.flagleft.getBounds().height + 20;

    this.btnGo = this.add.container(-180, -180);
    const btnGoBG = ABCyaPhaser.Buttons.addSimpleButton(0, 0, 'BtnGo', null, () => {
      btnGoBG.setEnabled(false);
      this.onClickGo();
    }, this.btnGo, { disabledTint: '0xFFFFFF' }).setEnabled(false);
    const btnTxt = this.add.bitmapText(0, -4, 'asapBold', ABCyaPhaser.Localization.instance.getLocalizedString('buttons.go'), 48).setTintFill('0xFFFFFF')
      .setOrigin(.5);
    this.btnGo.add(btnTxt);

    this.bigCar = ABCyaPhaser.Images.addImage(0, 0, 'BigCar', this);
    this.bigCar.x = this.mid.x * 2 + 220;
    this.bigCarDestY = 380;
    this.bigCar.y = this.mid.y * 2 - 200;
    this.bigCar.rotation = -90;

    this.layoutRatio();

    if (gameData.queueBusy) {
      // We aren't ready to start the game yet
      gameData.queueCompleteHandler = this.doCarIntro.bind(this);
    }
    else {
      this.doCarIntro();
    }
  }

  doCarIntro() {
    ABCyaPhaser.Audio.playOneShot('car_passby_fast_brake', this);

    this.carRotationTween = ABCyaPhaser.Tweens.addTween(this.bigCar, 880, { delay: 320, angle: 30 }, Phaser.Math.Easing.Quadratic.Out);
    this.carMoveTween = ABCyaPhaser.Tweens.addTween(this.bigCar, 1200, { x: 200, y: this.bigCarDestY }, Phaser.Math.Easing.Quadratic.Out);

    this.time.delayedCall(800, () => { this.doTitleIntro(); });
  };

  doTitleIntro() {
    ABCyaPhaser.Tweens.addTween(this.flagContainer, 330, { delay: 300, x: ABCyaLib.Environment.instance.gameConfig.results.resultsX, alpha: 1 }, Phaser.Math.Easing.Linear, () => { this.doGoButtonIntro(); });

    ABCyaPhaser.Audio.playSound('results', this.player);
  };

  doGoButtonIntro() {
    ABCyaPhaser.Audio.playOneShot('car_screech_short', this);

    ABCyaPhaser.Tweens.addTween(this.btnGo, 600, { x: this.mid.x + 170 }, Phaser.Math.Easing.Quadratic.Out, () => { this.btnGo.list[0].setEnabled(true); });

    ABCyaPhaser.Tweens.addTween(this.lblPlayAgain, 300, { alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
  };

  onClickGo() {
    this.sound.stopAll();
    if (gameData.GAME_TYPE === 'jr') {
      this.scene.start('Questions');
    }
    else {
      this.scene.start('Select');
    }
  };

  layoutRatio() {
    this.checkerFooter.y = this.mid.y * 2;
    this.btnGo.y = this.mid.y * 2 - this.btnGo.getBounds().height / 2 - 128;

    const scale = 1.0;
    this.bigCarDestY = 380;
    this.flagContainer.y = 180;
    this.bigCar.scale = scale;
    this.bigCar.y = this.bigCarDestY;
  };
}